import type { Application } from '@src/@types/app';
import { FILTERS_NAMES } from '@src/constants/filters';
import { ListKeys } from '@src/constants/microcredits';
import { getUserPhoneForChecker } from '@src/helpers/getUserPhoneForChecker';
import { CookieKey } from '@src/modules/cookie';
import { fetchOffers } from '@src/reducers/microcredits';
import { getCookieFromServerOrClient } from '@src/utils/getCookieFromServerOrClient';

const FULL_DEAL_AND_PING3_OFFERS_IDS = [
  '680a04234ca54b002cf2367c',
  '6788f1b8173156002849d4a9',
  '6788f71eb88e200026a16f21',
  '67890a24b88e200026a16f27',
  '6788ef47173156002849d4a5',
  '682b43095d1ae0002af39394',
  '682b43d70b8a9d002a096031',
  '682b450b0b8a9d002a09603a',
  '6734b8eba871da0027300346',
];

export const getFullDealAndPing3OffersPageData = async (ctx: Application.ReduxNextPageContext) => {
  const {
    store: { dispatch },
  } = ctx;

  const filterParams = getFilterParams(ctx);

  await dispatch(
    fetchOffers({
      query: {
        ...ctx.query,
        ids: FULL_DEAL_AND_PING3_OFFERS_IDS,
      },
      params: filterParams,
      key: ListKeys.FULL_DEAL_AND_PING3_OFFERS,
    }),
  );
};

function getFilterParams(ctx: Application.ReduxNextPageContext) {
  const clientId = getCookieFromServerOrClient(ctx, CookieKey._ym_uid);

  return {
    [FILTERS_NAMES.LOCATION]: ctx.params.locationRoute,
    [FILTERS_NAMES.METADATA]: true,
    [FILTERS_NAMES.ROUTE]: { asPath: ctx.asPath ?? '', query: ctx.query ?? {} },
    [FILTERS_NAMES.HAS_OFFERS_DUPLICATE]: false,
    ...(Boolean(clientId) && {
      [FILTERS_NAMES.CLIENT_ID]: clientId,
    }),
    ...getUserPhoneForChecker(ctx),
    ids: FULL_DEAL_AND_PING3_OFFERS_IDS,
  };
}
